























import moment from 'moment';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Trade, Exchange } from '@/types/trade';

@Component({
  name: 'TimeAndSales',
  filters: {
    formatDateTime(unixTime: number) {
      return moment(unixTime).format('HH:mm:ss');
    },
  },
})
export default class TimeAndSales extends Vue {
  @Prop(Object) public trade!: Trade;
  get exchangeName() {
    if (this.trade.exchange === Exchange.Bitfinex) {
      return 'Bitfinex';
    } else if (this.trade.exchange === Exchange.Bitflyer) {
      return 'bitFlyer';
    } else if ( this.trade.exchange === Exchange.Bitmex) {
      return 'BitMEX';
    }
  }
  get formatedPrice() {
    if (this.trade.exchange === Exchange.Bitflyer) {
      return this.trade.price;
    } else {
      return this.trade.price.toFixed(1);
    }
  }
  get IconClass() {
    const isBitfinex = this.trade.exchange === Exchange.Bitfinex;
    const isBitflyer = this.trade.exchange === Exchange.Bitflyer;
    const isBitmex = this.trade.exchange === Exchange.Bitmex;
    return {
      'green--text': isBitfinex,
      'indigo--text': isBitflyer,
      'red--text': isBitmex,
    };
  }
  get directionClass() {
    return {
      up: this.trade.direction! > 0,
      down: this.trade.direction! < 0,
    };
  }
}
